module.exports = __webpack_public_path__ + "img/52114143_L.6162880d.png";